<template>
  <div>
    <div class="m-b-20 ovf-hd">
      <div class="fl m-r-30">
        <el-button size="small" type="success" @click="$router.push({ name: 'user_add_companyList', params: { id: id }})"><i class="el-icon-plus"></i>&nbsp;&nbsp;添加企业</el-button>
      </div>
      <div class="fl w-400">
        <el-input placeholder="请输入企业号/企业名/联系人/电话/邮箱/部门/职位" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div><span class="m-l-30"><span style="font-size:20px;font-weight:700;margin-top:7px;color:#111;">{{user_name}}  ({{username}})</span></span>
    </div>
    <el-table
    :data="tableData"
    
    :height="setHeight.page_height"
    style="width: 100%"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="company_code"
      label="企业号">
      </el-table-column>
      <el-table-column
      prop="company_name"
      label="企业名">
      </el-table-column>
      <el-table-column
      prop="company_user"
      label="企业联系人">
      </el-table-column>
      <el-table-column
      prop="company_phone"
      label="企业电话">
      </el-table-column>
      <el-table-column
      prop="company_email"
      label="企业邮箱">
      </el-table-column>
      <el-table-column
      prop="breach_name"
      label="部门">
      </el-table-column>
      <el-table-column
      prop="position_name"
      label="职位">
      </el-table-column>
      <el-table-column
      label="状态">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.examine_status ==1" style="color:#0c0">通过</span>
            <span v-else-if = "scope.row.examine_status ==0" style="color:#bb0">审核中</span>
            <span v-else-if = "scope.row.examine_status ==-1" style="color:#d00">删除</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
      label="操作"
      width="260">
        <template scope="scope">
          <div>
            <span>
              <el-button size="small" type="danger" @click="confirmDelete(scope.row)">退出企业</el-button>
            </span>
            <span>
            </span>
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pos-rel p-t-20">
      <btnGroup :selectedData="multipleSelection" :type="'user'" v-on:closeMain="init"></btnGroup>
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/btn-user-company.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        user_name: '',
        username: '',
        keywords: '',
        multipleSelection: [],
        id: this.$route.params.id,
        limit: 15
      }
    },
    methods: {
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        console.log(val)
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      confirmDelete(item) {
        this.$confirm('确认退出该企业?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _g.openGlobalLoading()
          this.apiDelete('admin/user/user_company/', item.id).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', '退出成功')
              setTimeout(() => {
                _g.shallowRefresh(this.$route.name)
              }, 1500)
            })
          })
        }).catch(() => {
          // catch error
        })
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            id: this.$route.params.id,
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/user/user_company', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.user_name = data.name.user_name
            this.username = data.name.username
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('company-save')
      },
      editShow() {
        return _g.getHasRule('company-update')
      },
      deleteShow() {
        return _g.getHasRule('company-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// user_company.vue?31fd87e6